<template>
	<div id="general-view-component" class="router-view">
		<!-- <div>
			<router-link to="/usage"><i class="fas fa-user-secret"></i>{{ $t('usage_app_view') }}</router-link>
		</div> -->
		<div v-for="(fam, famIndex) in families" :key="fam.id" class="d-flex flex-column mb-3">
			<div class="d-flex align-items-center mb-3" :class="famIndex ? 'mt-2':''" :ref="fam.name">
				<switch-button v-model="fam.isDisplayed" :colorEnabled="fam.color" height="25px" :title="fam.isDisplayed ? $t('hide_family') : $t('display_family')" :leftPosition="false" @toggle="onToggleHandler(fam, 'displayFamily')">
					<template>
						<span class="family-title ml-1" :style="{ color: fam.color }">{{ fam.title }}</span>
					</template>
				</switch-button>
				<span>
					<switch-button v-if="hasDiscontinuedProducts(fam)" class="ml-4" v-model="fam.displayDiscontinuedProducts" :colorEnabled="fam.color" :leftPosition="false" :title="fam.displayDiscontinuedProducts ? $t('hide_discontinued_products') : $t('display_discontinued_products')" @toggle="onToggleHandler(fam, 'displayDiscontinuedProducts')">
						<template>
							<span class="family-discontinued-title mx-1">{{ $t('discontinued_products') }}</span>
						</template>
					</switch-button>
					<switch-button class="ml-4" :style="fam.isSearchingForUpdates ? 'pointer-events: none' : ''" v-model="fam.searchForUpdates" :colorEnabled="'#008000'" :leftPosition="false" :title="$t('checkUpdatesTitle')" @toggle="onToggleHandler(fam, 'searchForUpdates')">
						<span class="family-discontinued-title mx-1">{{ $t('checkUpdates') }}<i v-if="fam.isSearchingForUpdates" class="fas fa-spinner spinning ml-1"></i></span>
					</switch-button>
				</span>
			</div>
			<template v-if="!fam.isDisplayed">
				<div class="no-series-to-display">{{ $t('family_not_selected') }}</div>
			</template>
			<template v-else-if="!getFamilyDisplayedSeries(fam)">
				<div class="no-series-to-display">{{ $t('no_series_match_current_filters') }}</div>
			</template>
			<div v-else class="family-series-container d-flex flex-row flex-wrap">
				<series-tab v-for="(s) in familiesFiltered(fam)" :key="s.id" :series="s" :colorTab="fam.color" @seriesClicked="seriesClickedHandler"></series-tab>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import SeriesTab from '../components/SeriesTab.vue';
import SwitchButton from '../components/SwitchButton.vue';
import { CONSTANTS } from '../resources/constants.js';

export default {
	components: {
		'series-tab': SeriesTab,
		SwitchButton,
	},

	data() {
		return {
			isFirstTime: true,
		};
	},

	computed: {
		...mapState(['families', 'searchForUpdatesDoneOnce', 'stateMachine']),
	},

	methods: {
		...mapMutations(['setUserSettings', 'updateUsageTrackerStorage']),

		...mapActions(['getLocalIP', 'searchForUpdates']),

		familiesFiltered(family) {
			return family.series.filter((s) => this.getSeriesVisibility(s));
		},

		getFamilyDisplayedSeries(family) {
			return this.familiesFiltered(family).length;
		},

		getFamilyVisibility(family) {
			return this.getFamilyDisplayedSeries(family) > 0;
		},

		getSeriesVisibility(series) {
			if (series.isCatalogue) {
				return series.includedInPendrive || !series.family.displayOnlyPendriveSeries;
			}
			if (series.isDiscontinued) {
				return series.family.displayDiscontinuedProducts;
			}
			if (series.isUnderDevelopment && this.stateMachine.underDevelopmentVisible) {
				return true;
			}
			return false;
		},

		hasDiscontinuedProducts(family) {
			return family.series.find((s) => s.isDiscontinued) !== undefined;
		},

		onToggleHandler(family, type) {
			let dataArray = {};

			this.families.forEach((f) => { dataArray[f.id] = f.dataLocalStorage; });

			this.setUserSettings({ field: CONSTANTS.UserSettings.fieldsKeys.familySettings, array: dataArray });

			this.getLocalIP().then((localIp) => {
				this.updateUsageTrackerStorage({ field: CONSTANTS.UserSettings.fieldsKeys.generalFilters, data: { type, familyInfo: { id: family.id, title: family.title, isDisplayed: family.isDisplayed, displayDiscontinuedProducts: family.displayDiscontinuedProducts, searchForUpdates: family.searchForUpdates } }, localIp });
			});

			if (type === 'searchForUpdates' && family.searchForUpdates) {
				this.searchForUpdates(family);
			}
		},

		seriesClickedHandler(series) {
			this.$router.push({ name: 'Product', params: { url: series.url } });
		},
	},

	created() {
		if (!this.searchForUpdatesDoneOnce) {
			this.searchForUpdates();
		}
	},

	mounted() {
		document.title = 'Products - Home';
		if (this.stateMachine.currentFamily) {
			this.$refs[this.stateMachine.currentFamily.name][0].scrollIntoView();
		}
	},
};
</script>

<style lang="scss">
@font-face {
	font-family: 'Univers LT Std BoldCn';
	src: url('https://storage.googleapis.com/sharepoint-assets/webfonts/UniversLTStd-BoldCn.woff2')
			format('woff2'),
		url('https://storage.googleapis.com/sharepoint-assets/webfonts/UniversLTStd-BoldCn.woff')
			format('woff');
	font-weight: bold;
	font-style: normal;
}

@font-face {
	font-family: 'Univers LT Std Cn';
	src: url('https://storage.googleapis.com/sharepoint-assets/webfonts/UniversLTStd-Cn.woff2')
			format('woff2'),
		url('https://storage.googleapis.com/sharepoint-assets/webfonts/UniversLTStd-Cn.woff')
			format('woff');
	font-weight: normal;
	font-style: normal;
}
.family-series-container {
	gap: 0.75rem;
}

.no-series-to-display {
	font-size: 1rem;
}

.family-title {
	display: block;
	font-family: 'Univers LT Std Cn';
	font-size: 35px;
	font-weight: bold;
	letter-spacing: 1px;
}

.family-discontinued-title {
	display: block;
	font-family: 'Univers LT Std Cn';
	font-size: 16px;
	font-weight: normal;
	text-transform: uppercase;
}
</style>
